import { useState } from "react";
import { useForm } from "react-hook-form";
import { NotificationManager } from "react-notifications";
import { SolicitudesApi } from "../api/SolicitudesApi";
import { getErrorFromResponse } from "../../../../../../../utility/utils";

const BULTO_DISPONIBLE = { bulto_descartado: false, bulto_agotado: false };

// Repetición de un análisis validado desde el historial: primero se verifica si
// la solicitud puede repetirse y solo entonces se pide la confirmación
export const useRepeticionAnalisis = ({ onRepeticionCompletada }) => {
    const { verificarRepeticionAnalisis, repetirAnalisis, cargando } =
        SolicitudesApi();

    const [modalAbierto, setModalAbierto] = useState(false);
    const [solicitud, setSolicitud] = useState(null);
    const [disponibilidadBulto, setDisponibilidadBulto] =
        useState(BULTO_DISPONIBLE);

    const { register, watch, reset, handleSubmit } = useForm({
        defaultValues: { motivo: "", dato_correcto_confirmado: false },
    });

    // un bulto descartado o agotado ya no puede muestrearse, por lo que se
    // exige confirmar que el dato correcto está registrado en otra parte
    const requiereConfirmarDato =
        disponibilidadBulto.bulto_descartado ||
        disponibilidadBulto.bulto_agotado;

    const datoCorrectoConfirmado = watch("dato_correcto_confirmado");

    const IniciarRepeticion = async (item) => {
        try {
            const disponibilidad = await verificarRepeticionAnalisis(item.id);

            reset({ motivo: "", dato_correcto_confirmado: false });
            setDisponibilidadBulto(disponibilidad);
            setSolicitud(item);
            setModalAbierto(true);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "No fue posible verificar la solicitud.",
            );
            NotificationManager.error(errorMsg, "Error", 6000);
        }
    };

    const CerrarModal = () => setModalAbierto(false);

    const ConfirmarRepeticion = handleSubmit(async (data) => {
        try {
            await repetirAnalisis(solicitud.id, {
                motivo: data.motivo,
                dato_correcto_confirmado:
                    requiereConfirmarDato &&
                    Boolean(data.dato_correcto_confirmado),
            });

            NotificationManager.success(
                "La solicitud quedó pendiente de análisis.",
                "Éxito",
                3000,
            );
            setModalAbierto(false);
            onRepeticionCompletada();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "No fue posible repetir el análisis.",
            );
            NotificationManager.error(errorMsg, "Error", 6000);
        }
    });

    return {
        modalAbierto,
        solicitud,
        disponibilidadBulto,
        requiereConfirmarDato,
        datoCorrectoConfirmado,
        register,
        IniciarRepeticion,
        CerrarModal,
        ConfirmarRepeticion,
        cargando,
    };
};
